/**
 * HOCP Brand Logo — v4 (Enterprise Mint Teal rebrand · Feb 2026)
 * ---------------------------------------------------------------------------
 * Inline SVG mark: Deep Teal rounded square with a Mint Teal "H" cut-out.
 *
 *   • Palette: Mint #37F4B5 · Deep Teal #014751 · Midnight #021F21
 *   • Scalable, crisp at any DPR, no PNG bitmap staleness
 *   • Preserves the original three-variant API so every consumer
 *     (Sidebar, Login, header) continues to work unchanged.
 */
import { forwardRef } from "react";

const LOGO_SRC = "/brand/kriyple-logo.png";

export const HocpMark = forwardRef(function HocpMark(
  { size = 40, variant = "dark", className = "", ...rest },
  ref
) {
  return (
    <img
      ref={ref}
      src={LOGO_SRC}
      width={size}
      height={size}
      style={{ width: size, height: size, objectFit: "contain" }}
      className={`inline-block select-none ${className}`}
      alt="Hotel Operations Control Platform"
      draggable={false}
      {...rest}
    />
  );
});

/* ── Full wordmark (mark + "HOCP" typography) ───────────────────────────── */
export function HocpWordmark({
  size = 36,
  variant = "onLight",
  showTagline = false,
  tagline = "Operations",
  className = "",
}) {
  const onDark = variant === "onNavy";
  const inkPrimary   = onDark ? "#FFFFFF"                : "var(--brand-charcoal, #1A2425)";
  const inkSecondary = onDark ? "rgba(255,255,255,0.60)" : "var(--text-tertiary, #5A6E73)";

  return (
    <div className={`inline-flex items-center gap-2.5 ${className}`}>
      <HocpMark size={size} variant={variant}/>
      <div className="leading-none">
        <div
          className="font-display font-bold tracking-tight"
          style={{ color: inkPrimary, fontSize: size * 0.44, letterSpacing: "-0.01em" }}
        >
          HOCP
        </div>
        {showTagline && (
          <div
            className="mt-1 uppercase font-semibold"
            style={{ color: inkSecondary, fontSize: size * 0.24, letterSpacing: "0.22em" }}
          >
            {tagline}
          </div>
        )}
      </div>
    </div>
  );
}

export default HocpMark;
